import { multiFactor } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { isMfaVerifiedForUser } from '../services/mfaAuth';

function hasMfaSessionClaim(tokenResult) {
  const claims = tokenResult?.claims || {};
  const firebaseClaims = claims.firebase || {};
  return Boolean(firebaseClaims.sign_in_second_factor || claims.sign_in_second_factor);
}

function getEnrolledFactorCount(user) {
  try {
    return multiFactor(user).enrolledFactors.length;
  } catch {
    return 0;
  }
}

/**
 * Resolve admin access from Firestore role + Firebase Auth MFA session.
 */
export async function getAdminAccessState(user) {
  if (!user) {
    return {
      isAdmin: false,
      hasAdminRole: false,
      mfaEnrollmentRequired: false,
      needsMfaSignIn: false,
    };
  }

  const userDoc = await getDoc(doc(db, 'users', user.uid));
  const hasAdminRole = userDoc.exists() && userDoc.data()?.role === 'admin';

  if (!hasAdminRole) {
    return {
      isAdmin: false,
      hasAdminRole: false,
      mfaEnrollmentRequired: false,
      needsMfaSignIn: false,
    };
  }

  await user.reload();
  const tokenResult = await user.getIdTokenResult(true);
  const signedInWithMfa =
    hasMfaSessionClaim(tokenResult) || isMfaVerifiedForUser(user.uid);

  if (signedInWithMfa) {
    return {
      isAdmin: true,
      hasAdminRole: true,
      mfaEnrollmentRequired: false,
      needsMfaSignIn: false,
    };
  }

  const hasMfaEnrolled = getEnrolledFactorCount(user) > 0;

  if (!hasMfaEnrolled) {
    return {
      isAdmin: false,
      hasAdminRole: true,
      mfaEnrollmentRequired: true,
      needsMfaSignIn: false,
    };
  }

  return {
    isAdmin: false,
    hasAdminRole: true,
    mfaEnrollmentRequired: false,
    needsMfaSignIn: true,
  };
}
